import { TRAINING_VIDEOS_ACTIONS, TRAINING_VIDEOS_ACTION_TYPES } from "../actions/trainingVideos"
import { apiStatusInitialState, apiStatusStateType } from "../misc"

export type TrainingVideoType = {
  id: string,
  title: string,
  vimeoId: number
}

export type TrainingVideosStateType = {
  data: {
    items: TrainingVideoType[],
  }
  fetchStatus: apiStatusStateType
}

export const initialState: TrainingVideosStateType = {
  data: {
    items: [],
  },
  fetchStatus: apiStatusInitialState
}

export default (state = initialState, action: TRAINING_VIDEOS_ACTION_TYPES): TrainingVideosStateType => {

  switch (action.type) {
    case TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_START:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          loading: true,
        }
      }
    case TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          data: action.payload,
          fetchStatus: {
            ...state.fetchStatus,
            lastFetch: Date.now(),
            errorCode: null,
            developerMessage: null,
            userMessage: null,
            moreInfo: null,
            lastError: null,
            loading: false
          }
        }
      }
      // caution: break is omitted intentionally if the payload is falsey

    case TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_ERROR:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          ...action.error,
          lastError: Date.now(),
          loading: false
        }
      }
    default:
      return state
  }
}